// extracted by mini-css-extract-plugin
export default {"videoWr":"CommerceVideoScreen_videoWr__ORXU+","nexBtnSlide":"CommerceVideoScreen_nexBtnSlide__9Z0Rg"};